export default __webpack_public_path__ + "static/media/OPD_CARD_BLANK_2.731e60f4.png";